<template>
	<div class="starter-pc-cart" v-show="isReady">
		<rule-modal @close="setRules([])" />
		<loading v-if="processingCheckout">
			Processing Checkout
		</loading>
		<div class="container">
			<header-subtotal>
				<sub-total
					:is-in-stock="isPreBuildInStock"
					:total-cart-price="totalCartPrice"
					:shipping-info="shippingInfo"
					:button-class="{ 'disable-element': processingCheckout }"
					@shopify="goToShopify('Top')"
				>
					{{ processingCheckout ? "Processing..." : "Checkout" }}
				</sub-total>
			</header-subtotal>
			<hr>
			<pc-specs
				:display-details="false"
				:parts="prebuildParts"
				class="pc-specs"
			>
				<template #specs-heading>
					<specs-cart-heading :prebuild-details="prebuildVariantInCart" />
				</template>
			</pc-specs>
			<supply-shortage-note />
			<cart-features
				:prebuild-parts="prebuildParts"
				:current-accessories-cart="currentAccessoriesCart"
				:accessories="seriesAccessories"
			/>
			<cart-accessories-list />
			<div class="sub-total-container">
				<sub-total
					:is-in-stock="isPreBuildInStock"
					:total-cart-price="totalCartPrice"
					:shipping-info="shippingInfo"
					:button-class="{ 'disable-element': processingCheckout }"
					@shopify="goToShopify('Bottom')"
				>
					{{ processingCheckout ? "Processing..." : "Checkout" }}
				</sub-total>
			</div>
		</div>
	</div>
</template>

<script>
import ShopifyClient from "shopify-buy";
import { deviceType } from "@u/helpers";
import prebuildCartData from "../mixins/prebuildCartData";
import HeaderSubtotal from "./header-subtotal";
import PcSpecs from "./pc-specs";
import SpecsCartHeading from "./specs-cart-heading";
import CartFeatures from "./cart-features";
import CartAccessoriesList from "./accessories-list";
import SubTotal from "./sub-total";
import SupplyShortageNote from "./supply-shortage-note";
import RuleModal from "../prebuild-accessories-store/rule-modal";
import { gtmTrigger, gtmTrack } from "@/util/gtm";

export default {
	name: "PrebuildCart",
	components: {
		CartAccessoriesList,
		CartFeatures,
		HeaderSubtotal,
		PcSpecs,
		SpecsCartHeading,
		SubTotal,
		SupplyShortageNote,
		RuleModal
	},
	mixins: [prebuildCartData],
	data() {
		return {
			processingCheckout: false
		};
	},
	methods: {
		async goToShopify(buttonPosition) {
			this.processingCheckout = true;
			gtmTrigger.checkoutClick(buttonPosition);

			try {
				const currencyCode = {
					presentmentCurrencyCode: this.userCurrency
				};

				const {
					data: { bld_number: bldNumber, checkout_list: checkoutList }
				} = await axios({
					url: "/prebuild-series/starter-line/cart/checkout",
					method: "POST",
					headers: {
						token: CONFIG.SESSION
					}
				});

				const customAttributes = [
					{
						key: "bld_number",
						value: bldNumber
					},
					{
						key: "source_device",
						value: deviceType()
					},
					{
						key: "heap_uuid",
						value: localStorage.getItem("heap-uuid")
					},
					{
						key: "checkout",
						value: "starter-series"
					},
					{
						key: "preBuild",
						value: "1"
					},
					{
						key: "pcSKU",
						value: this.gtmPrebuildVariables.pcSKU
					},
					{
						key: "pcName",
						value: this.gtmPrebuildVariables.pcName
					},
					{
						key: "pcPrice",
						value: this.gtmPrebuildVariables.pcPrice
					},
					{
						key: "pcColor",
						value: this.gtmPrebuildVariables.pcColor || ""
					}
				];

				const shopifyClient = await ShopifyClient.buildClient({
					domain: process.env.MIX_SHOPIFY_DOMAIN,
					storefrontAccessToken: process.env.MIX_SHOPIFY_SDK_KEY
				});

				const checkout = await shopifyClient.checkout.create({
					customAttributes,
					...currencyCode
				});

				await shopifyClient.checkout.addLineItems(checkout.id, checkoutList);
				gtmTrack.userCheckout();
				location.href = checkout.webUrl;
			} catch (error) {
				this.processingCheckout = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.starter-pc-cart {
	background: $white;
	padding-bottom: 100px;
	overflow-x: hidden;

	hr {
		border-top: 1px solid #dadde0;
	}

	.sub-total-container {
		margin-top: 50px;
		display: flex;
		justify-content: flex-end;

		@media (min-width: 320px) and (max-width: 580px) {
			margin-top: 10px;
			justify-content: flex-start;
		}
	}
}
</style>
